/**
 * Who sees which audience share UI.
 *
 * Owner Access (`sharing_mode`) is only for the org that owns the population.
 * Partner invitees use org-grant scope (`RecipientShareDialog`) even when
 * `canEdit` is true (RND-2640 / RND-2710).
 */

export function isExternalCollaboratorAudience(input: {
  audienceOrganizationToken?: string | null
  viewerOrganizationToken?: string | null
}): boolean {
  return (
    !!input.audienceOrganizationToken &&
    !!input.viewerOrganizationToken &&
    input.audienceOrganizationToken !== input.viewerOrganizationToken
  )
}

export function shouldShowOwnerShareControls(input: {
  mayEdit: boolean
  canManageOrgSharing?: boolean
  audienceOrganizationToken?: string | null
  viewerOrganizationToken?: string | null
}): boolean {
  if (!input.mayEdit) {
    return false
  }
  if (input.canManageOrgSharing) {
    return false
  }
  if (
    isExternalCollaboratorAudience({
      audienceOrganizationToken: input.audienceOrganizationToken,
      viewerOrganizationToken: input.viewerOrganizationToken,
    })
  ) {
    return false
  }
  return true
}

export function shouldShowRecipientShareControls(input: {
  canManageOrgSharing?: boolean
}): boolean {
  return input.canManageOrgSharing === true
}
